import React from 'react';
import {
  StyledCardWrapper,
  StyledFeatureContainer,
  StyledFeatureWrapper,
  StyledGridContainer,
  StyledSection,
} from './RegistryCashFundSection.styles';
import { JoykitIconVariant } from '@components/JoykitIcon';
import { TextPairing } from '@components/TextPairing';
import { CC4CashCard, CashFundCard, GroupGiftingCard, ShipInfoCard } from './components';
import { TextPairingWithIcon } from './components/TextPairingWithIcon';
import { useTranslation } from 'react-i18next';

type featureType = {
  title: string;
  body: string;
  iconName: JoykitIconVariant;
};

export const RegistryCashFundSection = () => {
  const { t } = useTranslation('registry');
  const registryCashFundSection = t('registryCashFundSection');
  const FEATURES: Readonly<featureType[]> = registryCashFundSection.features as featureType[];

  return (
    <StyledSection as="section" id="RegistrycashFundSection">
      <TextPairing
        alignment="center"
        title={registryCashFundSection.title}
        titleTagName="h2"
        titleColor="mono1"
        titleVariant="hed56"
        body={registryCashFundSection.body}
        bodyColor="mono1"
        bodyVariant="dek20"
      />
      <StyledGridContainer>
        <CashFundCard />
        <StyledCardWrapper>
          <ShipInfoCard />
          <GroupGiftingCard />
          <CC4CashCard />
        </StyledCardWrapper>
      </StyledGridContainer>
      <StyledFeatureContainer>
        {FEATURES.map((feature, idx) => (
          <StyledFeatureWrapper key={idx}>
            <TextPairingWithIcon
              iconName={feature.iconName}
              iconColor="accentBlue4"
              title={feature.title}
              titleVariant="dek24"
              titleColor="mono1"
              body={feature.body}
              bodyVariant="featureCopy17"
              bodyColor="neutra5"
            />
          </StyledFeatureWrapper>
        ))}
      </StyledFeatureContainer>
    </StyledSection>
  );
};
